var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 31.5,
    stroke: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.489 31.831c0 14.36-11.64 26-26 26-14.359 0-26-11.64-26-26s11.641-26 26-26c14.36 0 26 11.64 26 26z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.169 35.784a1.68 1.68 0 01-1.68-1.68V21.991a1.68 1.68 0 113.36 0v12.113a1.68 1.68 0 01-1.68 1.68zM34.849 40.57a1.68 1.68 0 11-3.361 0 1.68 1.68 0 013.36 0z",
    fill: "#fff"
  })));
}
export default SvgFormWarning;